import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const movimientoService = {
  anularMovimientoById,
  guardarMovimiento,
  getMovimientosByIdPresupuesto,
  guardarMovimientoRange,
  getMovimientosByIdTipoGasto,
}

async function anularMovimientoById(idusuario, movimiento) {
  return await ApiBudgety.post('Movimiento/Delete/' + idusuario, movimiento, {
    headers: {
      ACCION: MenusSistema.presupuesto_asignado.accesos.ingresar_movimiento_egreso,
      MENU: MenusSistema.presupuesto_asignado.id,
    },
  })
}

async function guardarMovimiento(idusuario, idgasto, movimiento) {
  return await ApiBudgety.post('Movimiento/InsertOrUpdate/' + idusuario + '/' + idgasto, movimiento, {
    headers: {
      ACCION: MenusSistema.presupuesto_asignado.accesos.ingresar_movimiento_egreso,
      MENU: MenusSistema.presupuesto_asignado.id,
    },
  })
}

async function guardarMovimientoRange(idusuario, movimientos) {
  return await ApiBudgety.post('Movimiento/InsertOrUpdateRange/' + idusuario, movimientos, {
    headers: {
      ACCION: MenusSistema.presupuesto_asignado.accesos.ingresar_movimiento_egreso,
      MENU: MenusSistema.presupuesto_asignado.id,
    },
  })
}

async function getMovimientosByIdPresupuesto(id, rechazados, fechaInicial, fechaFinal) {
  if (fechaInicial && fechaFinal) {
    return await ApiBudgety.get('Movimiento/FindByIdPresupuestoFilterDate/' + id + '/' + rechazados + '/' + fechaInicial + '/' + fechaFinal)
  } else {
    return await ApiBudgety.get('Movimiento/FindByIdPresupuesto/' + id + '/' + rechazados)
  }
}

async function getMovimientosByIdTipoGasto(idTipoGasto, idPresupuesto, rechazados) {
  return await ApiBudgety.get('Movimiento/FindByIdTipoGastoAndIdPresupuesto/' + idTipoGasto + '/' + idPresupuesto + '/' + rechazados)
}
